import { once } from 'ramda';
import { useEffect } from 'react';
import { useQueryParamsStore, useAuthManager } from '@funtech-int/yango-shared';

import { CounterConfig, InitMetrikaParams, initMetrika } from '@/shared/lib/metrika';
import { useLocale } from '@/shared/hooks/useLocale';
import { useLogger } from '@/shared/hooks/useLogger';
import { clientConfig } from '@/config/client';

const { appName, appVersion, yandexMetrika } = clientConfig;

function getCounterConfig(params: { isAuthorized: boolean; lang: string }): CounterConfig {
    return {
        id: yandexMetrika.main,
        params: {
            clickmap: true,
            webvisor: true,
            params: {
                appName,
                appVersion,
                isAuthorized: params.isAuthorized,
                yaGDPRLang: params.lang,
            },
        },
    };
}

const initMetrikaOnce: (params: InitMetrikaParams) => void = once(initMetrika);

export function useInitMetrika() {
    const { isAuthorized } = useAuthManager();
    const { lang } = useLocale();
    const logger = useLogger();
    const trackedQueryParamsStore = useQueryParamsStore();

    useEffect(() => {
        initMetrikaOnce({
            scriptSrc: yandexMetrika.scriptSrc,
            counter: getCounterConfig({ lang, isAuthorized }),
            logger,
            trackedQueryParamsStore,
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
}
